import { Transition } from "@headlessui/react";
import { InView, useInView  } from "react-intersection-observer";
import { useState, useEffect } from "react";
import {content } from "./content.js";
import leadingLoopVideo from "./images/leadingLoopVideo.mp4"
import logo from "./images/logo.png"
import logoWide from "./images/sbank.png"

const text = "Our women leaders are more than pioneers. They are powerhouses for change, driving transformation across our business while bringing their unique perspectives as we help steer Africa’s growth.";

const Header = () => (
  <div className={`flex flex-row w-[950px]`}>
    <div className="w-1/2 flex flex-row justify-center items-center">
      <div className="w-[500px] flex flex-col justify-start p-3">
        <div className="text-white text-xl font-bentonModern uppercase tracking-wide">Inspired to Inspire.</div>
        <div className="text-white text-[120px] leading-none font-bold font-bentonModernBold uppercase tracking-wide">Why <span className="text-sbPeach">She</span> leads</div>        
        <div className="text-white text-xl font-bentonModernRegular pt-3">Corporate and Investment Banking</div>
      </div>
    </div>      
    <div className="w-1/2">
        <video className=" w-[500px]" autoPlay loop muted><source src={leadingLoopVideo} type="video/mp4" /></video>
    </div>  
  </div>
)

const BrandVoiceDisclaimer = () => (  
  <div className="flex flex-col justify-start max-w-[750px] w-full py-2">    
    
    <div className="flex flex-row justify-between gap-10 p-3 items-center max-w-[750px] w-full mb-5">       
    <img src={logoWide} alt="standard bank" className="animate-fade w-[180px]" />   
        <div className="flex flex-row ">    
            <div className="text-white text-sm font-roboto font-semibold pt-3 tracking-wide"> <span className="text-red uppercase font-semibold">BrandVoice</span> | Paid Program</div>
        </div>
    </div>
    <div>
        <hr className="w-full border-1 border-white" />  
    </div>    
    <div className="text-white text-xs font-roboto  pt-3">
        Aug 16, 2023, 09:00pm CAT
    </div>
</div>
)

/*
<div className="relative w-[850px] h-[750px] mb-[400px]">    
      <Scroll item={item} />
      </div>
*/
const FeaturedWoman = () => {
  return (
  <div>
      {content.map((item) => (      
      <div className="relative w-[850px] h-[750px] mb-[200px]">    
      <Scroll item={item} />
      </div>     
      ))}
  </div>
)
}

const Footer = () => (  
  <div className="flex flex-col justify-start max-w-[950px] w-full py-2">    
  <div className="text-white text-sm font-roboto font-bold p-3">
      Visit <a href="https://www.standardbank.com/cib" target="_blank" rel="noreferrer" className="text-sbPeach underline">www.standardbank.com/cib</a> to find out more about Why <span className="text-sbPeach">She</span> Leads.
  </div>
    <div className="flex flex-row justify-start p-3 items-center max-w-[750px] w-full mb-5">       
    <a href="https://www.standardbank.com/cib" target="_blank" rel="noreferrer">
        <img src={logoWide} alt="standard bank" className="animate-fade w-[250px]"/>        
       </a>
    </div>   
</div>
)



const TextBlock = ({ children }) => (
  <div className="flex flex-col justify-center items-center w-[750px] py-20">
        <span className="text-white text-3xl tracking-wide text-center font-bentonModernBook">
          {" "}
          {children}
        </span>
  </div>
);


const Scroll = ({ item }) => {

return (
  <InView triggerOnce={true} rootMargin="200px 0px">
          {({ inView, ref }) => (
            <div ref={ref}>
              <Transition.Root show={inView}>                 
                  <Transition.Child
                    as="h3"
                    enter="ease-in delay-[50ms] duration-[800ms] transition-all"
                    enterFrom="opacity-0 translate-x-12"
                    enterTo="opacity-100 translate-y-0"
                    className="text-white text-[100px] uppercase tracking-wide font-bold font-benton bg-sbBlue z-10 absolute bottom-[240px] left-0"
                  >
                   {item.first} 
                  </Transition.Child>
                  <Transition.Child
                    as="h3"
                    enter="ease-in delay-[50ms] duration-[800ms] transition-all"
                    enterFrom="opacity-0 -translate-x-20"
                    enterTo="opacity-100 translate-y-0"
                    className="text-white text-[100px] uppercase font-bold tracking-wide font-benton pr-4 bg-sbBlue absolute bottom-[130px] left-[100px] z-10"
                  >
                   {item.last} 
                  </Transition.Child>
                  <img src={item.image} alt={item.name} className="w-[500px] absolute right-0 top-0" />    
                  <Transition.Child
                    as="span"
                    className="text-white text-[22px] tracking-wide font-benton top-0 left-0 absolute w-[350px] leading-snug"
                    enter="ease-in delay-[400ms] duration-[400ms] transition-all"
                    enterFrom="opacity-0 translate-y-0"
                    enterTo="opacity-100 translate-y-0"
                  >
                     "{item.quote}"
                  </Transition.Child>
                  <Transition.Child
                    as="span"
                    className="text-sbPeach bg-sb text-[20px] uppercase tracking-wide font-benton bottom-0 left-0 absolute w-[350px] leading-tight"
                    enter="ease-in delay-[800ms] duration-[600ms] transition-all"
                    enterFrom="opacity-0 translate-y-12"
                    enterTo="opacity-100 translate-y-0"
                  >
                     {item.title} 
                  
                </Transition.Child>
              </Transition.Root>
            </div>
          )}
        </InView>

)};


const Content = ({ contentStyle }) => (


      <div className={`flex flex-col items-center justify-center`} style={contentStyle}>       
          <Header />
          <BrandVoiceDisclaimer />        
          <TextBlock>{text}</TextBlock> 
          <FeaturedWoman />
          <Footer />
      </div>

);



const LeadingWoman = () => {

  const baseWidth = 1000;
  const baseHeight = 720;
  const contentHeight = 11000;
  
  const [contentStyle, setContentStyle] = useState({});
  const [wrapperStyle, setWrapperStyle] = useState({});

  const updateScale = () => {
    const newScale = Math.min(
      window.innerWidth / baseWidth,
      window.innerHeight / baseHeight
    );

    //1000 
    //784

    //for every pixel under 1000 width we meed to move the content up by 4.6 pixels

    const hDelta = baseWidth - window.innerWidth;

    const translateY = hDelta * 11.2; //5.34
    
    //console.log(translateY, newScale);

    if(newScale < 1) {
      setContentStyle({
        transform: `scale(${newScale})`        
      });
      setWrapperStyle({
        //transform: `translateY(-${translateY}px)`,      
        height: `${contentHeight - translateY }px`,
      });           
    } else {
      setContentStyle({});
      setWrapperStyle({});
    }

  };

  useEffect(() => {
    updateScale(); // Initial scaling
    window.addEventListener('resize', updateScale);

    return () => {
      window.removeEventListener('resize', updateScale);
    };
  }, []);

 
  return (
    
    <div className={`bg-sbBlue w-full h-full`}>
      <div className={`flex flex-col items-center justify-center`} style={wrapperStyle}>
      <Content  contentStyle={contentStyle} />
      </div>
    </div>
    
   
    
  

       
  );
};

export default LeadingWoman;
